import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import CategoryFeatureGrid from './components/CategoryFeatureGrid';
import CategoryCardGrid from './components/CategoryCardGrid';
import CategoryCardGridB from './components/CategoryCardGridB';
import SeoContentSection from './components/SeoContentSection';
import TrustSection from './components/TrustSection';
import FinalFeatureGrid from './components/FinalFeatureGrid';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    // Schema.org structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      'name': 'Superbuy Spreadsheet | Fashion Product Discovery Platform',
      'description': 'Superbuy Spreadsheet is a structured collection of fashion product resources that helps shoppers discover and organize items across 14 curated categories.',
      'url': 'https://superbuyspread.ink/',
      'mainEntity': {
        '@type': 'FAQPage',
        'mainEntity': [
          {
            '@type': 'Question',
            'name': 'What is Superbuy Spreadsheet?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'Superbuy Spreadsheet is a structured shopping resource that organizes product links, categories, and research information across 14 fashion categories. It helps shoppers discover and organize items efficiently without browsing multiple websites individually.'
            }
          },
          {
            '@type': 'Question',
            'name': 'How many categories does Superbuy Spreadsheet cover?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'Superbuy Spreadsheet covers 14 distinct fashion categories including Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and Other Stuff.'
            }
          },
          {
            '@type': 'Question',
            'name': 'How often is Superbuy Spreadsheet updated?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'The Superbuy Spreadsheet is updated weekly to ensure all product links remain current and new collections are added as they become available.'
            }
          },
          {
            '@type': 'Question',
            'name': 'Is Superbuy Spreadsheet free to use?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'Yes, the Superbuy Spreadsheet resource is freely accessible. You can browse all 14 categories and access the complete product discovery platform at no cost.'
            }
          },
          {
            '@type': 'Question',
            'name': 'How do beginners use Superbuy Spreadsheet?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'Beginners can start by browsing the category dropdown menu or clicking on any featured category card. Each category links directly to organized product collections, making it simple to navigate even for first-time online shoppers.'
            }
          }
        ]
      }
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <main>
      <HeroSection />
      <CategoryFeatureGrid />
      <CategoryCardGrid />
      <SeoContentSection />
      <CategoryCardGridB />
      <TrustSection />
      <FinalFeatureGrid />
      <CtaSection />
      <Footer />
    </main>
  );
}